<template>
  <div v-if="showUniversalFilter">
    <el-tooltip :content="placeholder" placement="top" effect="light" :open-delay="300" transition="el-zoom-in-top">
      <el-input v-model="value" clearable @input="onInput" :placeholder="placeholder" :class="{ 'is-active': value }" />
    </el-tooltip>
  </div>
</template>

<script>
import { debounce, get } from 'lodash'

export default {
  name: 'FilterUniversal',
  computed: {
    placeholder() {
      return this.$i18n.t(get(this.$get('universalFilter'), 'placeholder'))
    },
    showUniversalFilter() {
      return this.$get('visibilityState')({ key: 'showUniversalFilter' })
    },
    value: {
      get() {
        return get(this.$get('universalFilter'), 'value')
      },
      set(value) {
        this.$dispatch('setUniversalFilter', { value })
      },
    },
  },
  methods: {
    onInput: debounce(function () {
      this.$emit('apply-filter')
    }, 500),
  },
}
</script>

<style lang="scss" scoped>
.is-active {
  box-shadow: 0 0 8px $color-not-set;
  border-radius: 8px;
}
</style>
